import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

export const impressShowNewMegamenu = () => GrowthDiscoveryExperiments.get('simplifiedMegamenuQ12025');

export const shouldShowNewMegamenu = () => GrowthDiscoveryExperiments.preview('simplifiedMegamenuQ12025') !== 'control';
export const isInNewMegamenuVariantB = () => GrowthDiscoveryExperiments.preview('simplifiedMegamenuQ12025') === 'B';
export const isInNewMegamenuVariantC = () => GrowthDiscoveryExperiments.preview('simplifiedMegamenuQ12025') === 'C';
